import { useMutation } from 'react-query';
import { IServerErrorResponse } from '../../../../../types';
import { useStore } from '../../../../../store';
import { BASE_URL } from '../../../../../constants/endpoints';
import { httpService } from '../../../../../services/http.service';
import { IBillItem } from '../../../types';

interface IProps {
    billId: string,
    email: string
}

export const postRequestVendorDetails = (onSuccess: (billItem: IBillItem) => void, onError: (data: IServerErrorResponse) => void) => {
  const { getPersonalAccount, user: { customerId } } = useStore(state => state);
  const { accountExternalId } = getPersonalAccount();

  return useMutation(
    async (props: IProps) => {
      const { data } = await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/${accountExternalId}/bill/${props.billId}/requestVendorDetails`, {
        email: props.email,
      });
      return data as IBillItem;
    },
    {
      onSuccess,
      onError,
    },
  );
};
